<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'FAQ',

    metaInfo: { title: 'Frequently Asked Questions' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-short',
        'html-faq-content',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'FAQ',
      },
    },
  }
</script>
